import { Toast } from "primereact/toast";
import { useEffect, useRef, useState } from "react";
import { PurpleButton } from "../../components/buttons/purpleButton";
import { ImageUpload } from "../../components/imageUpload";
import { TextBox } from "../../components/textBox";
import { useUploadingState } from "../../hooks/useUploadingState";
import publicidadesService from "../../services/publicidadesService";
import { scrollUp } from "../../utils/pageUtils";
import { IPublicidades } from "./../../interfaces/model/iPublicidade";
import {
  Container,
  DivAdsSloteMobile,
  DivAdsSloteWeb,
  DivDefault,
  DivImageAds,
  DivTitle,
  HomeAdsDiv,
  LinkAndSubmit,
} from "./style";

type ToastType = "error" | "success" | "warn";
const TOAST_SUMMARIES: Record<ToastType, string> = {
  error: "Erro",
  success: "Sucesso",
  warn: "Atenção",
};

export const PostAds = () => {
  const toast = useRef<Toast>(null);
  const [adsList, setAdsList] = useState<IPublicidades[]>([]);
  const [selectedName, setSelectedName] = useState<string>("");
  const [selectedImageWeb, setSelectedImageWeb] = useState<string>("");
  const [selectedImageMobile, setSelectedImageMobile] = useState<string>("");
  const [selectedLink, setSelectedLink] = useState<string>("");
  const webUpload = useUploadingState();
  const mobileUpload = useUploadingState();
  const isUploading = webUpload.isUploading || mobileUpload.isUploading;

  useEffect(() => {
    scrollUp();
    publicidadesService
      .getAllAds()
      .then((res) => {
        setAdsList(res.data);
      })
      .catch((err) => {
        toastMessage("Falha ao obter ads", "error");
      });
  }, []);

  const handleUpdateAds = () => {
    if (webUpload.uploadingRef.current || mobileUpload.uploadingRef.current) {
      toastMessage("Aguarde os envios de imagem terminarem.", "warn");
      return;
    }

    if (selectedAds) {
      const updatedAds = { ...selectedAds };

      if (selectedImageWeb) {
        updatedAds.imagemWeb = selectedImageWeb;
      }

      if (selectedImageMobile) {
        updatedAds.imagemMobile = selectedImageMobile;
      }

      if (selectedLink) {
        updatedAds.linkUrl = selectedLink;
      }
      const data = {
        nome: selectedAds.nome,
        imagemWeb: selectedImageWeb,
        recomendadoWeb: selectedAds.recomendadoWeb,
        imagemMobile: selectedImageMobile,
        recomendadoMobile: selectedAds.recomendadoMobile,
        linkUrl: selectedLink === "" ? selectedAds.linkUrl : selectedLink,
      };

      publicidadesService
        .putAds(updatedAds.id!, data) // Pass the id as the first argument
        .then((res) => {
          if (res.status === 200) {
            toastMessage("Ads atualizado com sucesso", "success");
          }
        })
        .catch((err) => toastMessage("Falha ao atualizar ads.", "error"));
    }
  };

  const selectedAds = adsList.find((ads) => ads.nome === selectedName);
  const handleSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    if (webUpload.uploadingRef.current || mobileUpload.uploadingRef.current) {
      toastMessage("Aguarde os envios de imagem terminarem.", "warn");
      return;
    }

    const name = e.target.value;
    setSelectedName(name);
    const ads = adsList.find((item) => item.nome === name);
    setSelectedImageWeb(ads?.imagemWeb ?? "");
    setSelectedImageMobile(ads?.imagemMobile ?? "");
    setSelectedLink(ads?.linkUrl ?? "");
  };

  function toastMessage(message: string, type: ToastType) {
    toast.current?.show({
      severity: type,
      summary: TOAST_SUMMARIES[type],
      detail: message,
      life: 3000,
    });
  }

  return (
    <>
      <Toast ref={toast} />
      <Container>
        <HomeAdsDiv>
          <DivTitle>
            <h1 style={{ color: "#fff" }}>Adicionar Ads</h1>
            <select
              aria-label="Publicidade para atualizar"
              disabled={isUploading}
              value={selectedName}
              onChange={handleSelectChange}
            >
              <option value="">Selecionar</option>
              {adsList.map((ads) => (
                <option key={ads.id} value={ads.nome}>
                  {ads.nome}
                </option>
              ))}
            </select>
          </DivTitle>
          <DivImageAds>
            {selectedAds ? (
              <>
                <DivAdsSloteWeb>
                  <h2 style={{ color: "#fff" }}>Imagem Web</h2>
                  <h4
                    style={{ color: "#fff" }}
                  >{`Recomendado: ${selectedAds.recomendadoWeb}`}</h4>
                  <ImageUpload
                    value={selectedImageWeb}
                    onChange={setSelectedImageWeb}
                    category="ADS"
                    contentId={selectedAds.id}
                    label=""
                    onUploadingChange={webUpload.onUploadingChange}
                  />
                </DivAdsSloteWeb>
                <DivAdsSloteMobile>
                  <h2 style={{ color: "#fff" }}>Imagem Mobile</h2>
                  <h4
                    style={{ color: "#fff" }}
                  >{`Recomendado: ${selectedAds.recomendadoMobile}`}</h4>
                  <ImageUpload
                    value={selectedImageMobile}
                    onChange={setSelectedImageMobile}
                    category="ADS"
                    contentId={selectedAds.id}
                    label=""
                    onUploadingChange={mobileUpload.onUploadingChange}
                  />
                </DivAdsSloteMobile>
              </>
            ) : (
              <DivDefault>
                <p>Selecione um Ads</p>
              </DivDefault>
            )}
          </DivImageAds>
          {selectedAds && (
            <LinkAndSubmit>
              <TextBox
                title="Digite o novo link do anunciante"
                value={selectedLink}
                onChangeText={setSelectedLink}
                height="48px"
              />
              <div style={{ margin: "16px" }} />
              <PurpleButton
                title="Atualizar"
                onClick={handleUpdateAds}
                disabled={isUploading}
              />
            </LinkAndSubmit>
          )}
        </HomeAdsDiv>
      </Container>
    </>
  );
};
